import { render, staticRenderFns } from "./FacilityItem.vue?vue&type=template&id=f51a908c&"
import script from "./FacilityItem.vue?vue&type=script&lang=ts&"
export * from "./FacilityItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports